<div class="row d-flex justify-content-end">
    <a class="btn btn-sm btn-dark mr-5" [routerLink]="['/admin_panel/porfilo_buckets']" routerLinkActive="router-link-active" >Back</a>
</div>

<div style="margin-right: 32px;">
  <div>
      <h4 class="title" style="margin-top: 15px;">Portfolio List</h4>
      <!-- <button (click)="Change_list('portfolio')">
        Portfolio List
      </button>
      <button (click)="Change_list('fint_dup')">
        Duplication Fint Id
      </button>
      <button (click)="Change_list('acc_dup')">
        Duplication Passort & ACC
      </button> -->
  </div>
</div>

<div class="card" style="padding: 10px; border-radius:10px;">
  <!-- 
      <div>
          <p><b>BANK NAME: </b> <span style="font-size: 16px; color:#2196f3;"> {{bucket_detail.bank_name.bank_name}}</span></p>
      </div>
      <div>
          <p><b>PORTFOLIO: </b> <span style="font-size: 16px; color:#2196f3;"> {{bucket_detail.portfolio_id.portfolio_type}}</span></p>
      </div>
      <div>
          <p><b>PRODUCT: </b> <span style="font-size: 16px; color:#2196f3;"> {{bucket_detail.product_id.product_type}} </span></p>
      </div>
      <div>
        <p><b>Bucket_numer: </b> <span style="font-size: 16px; color:#2196f3;"> {{bucket_detail.bucket_id}} </span></p>
    </div>
  </div> -->
</div>

<!--
<div class="col-md-12">
<h5 class="form-lable">Company Name</h5>
<p-dropdown [options]="Company_details" [(ngModel)]="company_name"
    placeholder="Company Type" optionLabel="y" [showClear]="true"></p-dropdown>
</div> -->

<br>
<!-- <div class="col-md-6">
<h5 class="form-lable">Choose Designations</h5>
<p-dropdown [options]="Designation_details1" (onChange)="fetchuser_1()" [(ngModel)]="report_to_design"
  placeholder="Report to Designations" optionLabel="y" [showClear]="true"></p-dropdown>
</div> -->


<!-- <div class="col-md-6">
<h5 class="form-lable">Choose User Details</h5>
<p-dropdown [options]="User_details1" (onChange)="Report_fetch()" [(ngModel)]="report_to"
  placeholder="Report to User Details" optionLabel="y" [showClear]="true"></p-dropdown>
</div> -->





<div style="margin: 2px;padding-bottom: 15px;">

  <div class="row">
      <div class="col-12">
          <p>Total Outstanding Amount: &nbsp; &nbsp;<b>{{total_out_standing | currency:'AED '}}</b></p>
          <p>User Account : &nbsp; &nbsp; <b>{{saved_Fields.length}}</b></p>

        </div>

      <div class="col-md-12">
          <div>
              <!-- <h4 class="title-f" style="color: #0a2440;font-weight: 600;border-bottom: 2px solid;">Accounts Details</h4>
          <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"
              style="width: auto;margin-right: 5px;position: relative;top: 2px;">
          <label for="vehicle1" style="font-weight: 600;font-size: 12px;"> Select All</label><br> -->
          <!-- <div style="text-align: right;">
              <button class="btn btn-primary" style="margin-top: -25px;" (click)="submit_allocation()">Click here to Save Allocate</button>
          </div> -->
          <h4 class="title-f">New Accounts</h4>

         <div class="animate" *ngIf="!loading">

         </div>
          <div *ngIf="loading" >
              <!-- <ag-grid-angular #agGrid
                  style="width: auto; height: 600px;"
                  class="ag-theme-alpine"
                  [rowData]="Finals_excel"
                  [rowSelection]="'multiple'"
                  [columnDefs]="columnDefs"
                  [pagination]="true">
              </ag-grid-angular> -->


      <div class="card-box"> <p-table [value]="saved_Fields | filterBy:userFilter" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="25"
          [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [globalFilterFields]="['type']">
          <ng-template pTemplate="header">
              <tr class="thhead">

                  <th class="th-1">
                      S.No
                  </th>
                  <th>
                    Customer Name
                 </th>
                  <th>
                     Customer id
                  </th>
                  <th>
                     Passport no
                  </th>
                  <th>
                    Acc no
                  </th>
                  <th>
                    agreement no
                  </th>
                  <th>
                    CIF
                  </th>
                  <th>
                      Total Out Standing
                  </th>
                  <th>
                      Card
                  </th>
                  <th>
                      Loan
                  </th>
                  <th>
                      Segment
                  </th>
                  <th>
                      CBQ Mob No
                  </th>
                  <th>
                      Email Address
                  </th>
                  <th>
                      Status Of Accounts
                  </th>
                  <th>
                      Contactable
                  </th>
                  <th>
                      Short Code
                  </th>
                  <th>
                    nationality
                  </th>
                  <th>
                    cycle
                  </th>
                  <th>
                    flow status
                  </th>

                  <th style="width: 110px;text-align:center">
                      More Details
                  </th>
              </tr>
              <tr>
                  <th></th>
                  <th> <input class="form-control" type="text" (change)="getname($event)"> </th>
                  <th> <input class="form-control" type="text" (change)="getFin($event)"> </th>
                  <th> <input class="form-control" type="text" (change)="getPass($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getAcc($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getAgg($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getCif($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getOTS($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getCard($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getLoan($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getSegment($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getMobile($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getEmail($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getStatus($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getContactable($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getShortCode($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getnat($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getcycle($event)"></th>
                  <th> <input class="form-control" type="text" (change)="getflow($event)"></th>


                  <th></th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr class="tdrow" (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)" >
                  <td>{{i+1}}</td>
                  <td>{{item.customer_name }}</td>
                  <td>{{item.customer_id }}</td>
                  <td>{{item.passport_no }}</td>
                  <td>{{item.acc_no }}</td>
                  <td>{{item.agreement_id }}</td>
                  <td>{{item.cif }}</td>
                  <td>{{item.total_out_standing}}</td>
                  <td>{{item['Cr. Card Dues']}}</td>
                  <td>{{item['Loan Dues']}}</td>
                  <td>{{item['A/c Segment']}}</td>
                  <td>{{item['Qatar Mobile No']}}</td>
                  <td>{{item['Email ID']}}</td>
                  <td>{{item['Status Of Accounts']}}</td>
                  <td>{{item.Contactable}}</td>
                  <td>{{item['Short Code']}}</td>
                  <td>{{item.nationality }}</td>
                  <td>{{item.cycle  }}</td>
                  <td>{{item.flow_status }}</td>
                  
                  <!-- <td>{{item.bucket}}</td>
                  <td>{{item.product_name}}</td>
                  <td>{{item.bank_allocation}}</td> -->
                  <td class="act">
                      <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true" pTooltip="View More Details" (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)" ></i>
                  </td>
              </tr>
              <!-- {{item|json}} -->
          </ng-template>
       </p-table>  
      </div>
          </div>
        </div>
      </div>

  </div>





  
</div>
